import Form from 'components/Form';

import { Fragment } from 'react';
import { Typography } from '@mui/material';

import RowContainer from '../../components/RowContainer';
import RowContent from '../../components/RowContent';

import { Ti18nId } from 'hooks/useI18n';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  onRequired: (id: Ti18nId) => void;
  onSuccess: (message: string) => void;
}

const GuardianInfo = (props: Props) => {
  const { disabled, register } = props;

  const infos = [
    {
      title: 'A. Lý do sử dụng  sự kiềm chế bằng phương pháp vật lý',
      value: 'no2_1',
    },
    {
      title:
        'B. Các phương pháp thay thế được sử dụng thay vì các biện pháp kiềm chế bằng phương pháp vật lý và hiệu quả của chúng',
      value: 'no2_2',
    },
    {
      title:
        'C.  Phạm vi áp dụng, loại hình và kỹ thuật sử dụng sự kiềm chế bằng phương pháp vật lý',
      value: 'no2_3',
    },
    {
      title:
        'D.  Tác dụng phụ và biện pháp phòng ngừa trong quá trình sử dụng  sự kiềm chế bằng phương pháp vật lý',
      value: 'no2_4',
    },
    { title: 'E. Vấn đề khác', value: 'no2_5' },
  ];

  const labels = [
    { title: '', variable: '' },
    { title: 'Bác sĩ', variable: 'no2_dr_name' },
    { title: 'Chữ ký của bác sĩ', variable: 'no2_dr_sign' },
  ];

  return (
    <Fragment>
      <SectionTitle title="2. Mô tả và Chi tiết (Phải bao gồm các mục A đến E)" />
      <RowContainer xs={11.5} sx={{ margin: '20px 0px 30px 0px' }}>
        {infos.map(({ title, value }) => (
          <>
            <Typography
              sx={{
                lineHeight: '20px',
                margin: '20px 0 0 15px',
                fontSize: '14px',
              }}
            >
              {title}
            </Typography>
            <Form.MuiTextField
              sx={{
                margin: '0px 0 0 15px',
              }}
              multiline
              minRows={3}
              required={false}
              disabled={disabled}
              {...register(`${value}`)}
            />
          </>
        ))}

        {labels.map(({ title, variable }, _) => (
          <>
            {Array(2)
              .fill(0)
              .map(() => (
                <RowContent titleRatio={1.5} childrenRatio={2.5} />
              ))}
            {variable === '' ? (
              <RowContent
                key={variable}
                title={title}
                titleRatio={1.5}
                childrenRatio={2.5}
              ></RowContent>
            ) : (
              <RowContent
                key={variable}
                title={title}
                titleRatio={1.5}
                childrenRatio={2.5}
              >
                <Form.MuiTextField
                  disabled={disabled}
                  required={false}
                  {...register(`${variable}`)}
                />
              </RowContent>
            )}
          </>
        ))}
      </RowContainer>
    </Fragment>
  );
};

export default GuardianInfo;
